import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import { Table } from "antd";

import css from "./AvailableListDishesComponent.module.css";
import {availableDishesActions} from "../../../store/slices/menu-slices";
import {useInitCalendarDate} from "../../../helpers";
import { ImageReusable } from "../../../ui";

const AvailableListDishesComponent = () => {
    useInitCalendarDate(); // ✅ дата перед рендером

    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const {availableDishesArray, trigger, dataOfDay, status} = useSelector(store => store.availableDishes);

    useEffect(() => {
        if (dataOfDay) {
            dispatch(availableDishesActions.getAllAvailableDishes({currentData: dataOfDay}));
        }
    }, [trigger, dataOfDay, dispatch]);

    const columns = useMemo(() => {
        const currentLanguage = i18n.language;

        return [
            {
                title: t('Image'),
                dataIndex: ['dish', 'img'],
                key: 'img',
                width: '10%',
                render: (img) => (
                    <div className={css.imageCell}>
                        <ImageReusable
                            src={img}
                            className={css.imageTag}
                            alt="Food Image"
                        />
                    </div>
                ),
            },
            {
                title: t('modal-name-input-new-category'),
                dataIndex: ['dish', 'name'],
                key: 'name',
                width: '25%',
                render: (name, record) => {
                    const displayName = name?.[currentLanguage] || name?.["en"] || "";
                    const { energy, proteins, fats, carbs } = record.dish;
                    
                    return (
                        <div className={css.nameWrapper}>
                            <div className={css.dishName}>{displayName}</div>
                            <div className={css.nutritionInfo}>
                                <span className={css.nutritionItem}>
                                    <span className={css.nutritionLabel}>Energy:</span>
                                    <span className={css.nutritionValue}>{energy || 0} kcal</span>
                                </span>
                                <span className={css.nutritionItem}>
                                    <span className={css.nutritionLabel}>P:</span>
                                    <span className={css.nutritionValue}>{proteins || 0}g</span>
                                </span>
                                <span className={css.nutritionItem}>
                                    <span className={css.nutritionLabel}>F:</span>
                                    <span className={css.nutritionValue}>{fats || 0}g</span>
                                </span>
                                <span className={css.nutritionItem}>
                                    <span className={css.nutritionLabel}>C:</span>
                                    <span className={css.nutritionValue}>{carbs || 0}g</span>
                                </span>
                            </div>
                        </div>
                    );
                },
            },
            {
                title: t('Weight'),
                dataIndex: ['dish', 'weight'],
                key: 'weight',
                width: '10%',
                align: 'center',
                render: (weight) => weight || 0,
            },
            {
                title: t('weight-netto'),
                dataIndex: ['dish', 'weightNetto'],
                key: 'weightNetto',
                width: '10%',
                align: 'center',
                render: (weightNetto) => weightNetto || 0,
            },
            {
                title: t('modal-price'),
                dataIndex: ['dish', 'price'],
                key: 'price',
                width: '10%',
                align: 'center',
                render: (price) => price || 0,
            },
            {
                title: t('Cost'),
                dataIndex: ['dish', 'cost'],
                key: 'cost',
                width: '10%',
                align: 'center',
                render: (cost) => cost || 0,
            },
            {
                title: t('Category'),
                dataIndex: ['dish', 'categories'],
                key: 'category',
                width: '15%',
                render: (categories) => {
                    return categories
                        ?.map((category) => category.name?.[currentLanguage] || category.name?.["en"])
                        .join(", ") || t("unknown-category");
                },
            },
            {
                title: t('Times used in menus'),
                dataIndex: ['menuDishesCount'],
                key: 'menuDishesCount',
                width: '10%',
                render: (menuDishesCount) => menuDishesCount || 0,
            },
        ];
    }, [t, i18n.language]);

    return (
        <div className={css.wrap}>
            <Table
                columns={columns}
                dataSource={availableDishesArray}
                rowKey={(record) => record.id}
                pagination={false}
                loading={status === 'Loading'}
                locale={{ emptyText: status === 'rejected' ? 'No data' : t('no-data') }}
                className={css.dishesTable}
            />
        </div>
    );
};

export default React.memo(AvailableListDishesComponent);
